import React from "react";
import { IUIPropertyDefinition } from "../../../common/common";
import { PropertyContainer, PropertyContainerTitle, PropertyGroup } from "../../../common/ui-props/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Label } from "uxp/components";
import { generateUUID } from "../../../../util";
import { WidgetDesignerPillInput } from "../../../common/pill-input/PillInput";

interface IField {
    id: string,
    label: string,
    value1: string,
    value2: string
}
interface IDetailsCardProps {
    fields: IField[]
}

export function DetailsCardProperty(title: string, defaults: IDetailsCardProps): IUIPropertyDefinition<IDetailsCardProps> {
    return {
        defaults: defaults,
        render: (props, uxpContext, data, containerId) => {

            const _props = props?.uiProps || { fields: [] }
            if (!_props.fields) _props.fields = []


            function addNew() {
                const _fields = _props?.fields || []

                _fields.push({
                    id: generateUUID(),
                    label: '',
                    value1: '',
                    value2: ''
                })

                _props.fields = _fields
                props.onChange(Object.assign({}, _props))
            }

            function updateFieldProps(index: number, field: string, value: string) {
                const updated = (_props.fields || []).map((f, i) => {
                    if (i == index) {
                        (f as any)[field] = value
                    }
                    return f
                })
                _props.fields = updated
                props.onChange(Object.assign({}, _props))
            }

            return <PropertyContainer>
                <PropertyContainerTitle>Detail Fields</PropertyContainerTitle>
                <PropertyGroup>

                    <div className="wd-mobile-navigation-tabs-config-container">
                        <React.Fragment>
                            {_props?.fields?.map((f, i) => (<div className="wd-mobile-navigation-tabs-config-tab">
                                <div className="wd-mobile-navigation-tabs-config-tab-remover"
                                    onClick={() => {
                                        const _fields = [..._props.fields].filter(_f => _f.id !== f.id)
                                        _props.fields = _fields
                                        props.onChange(Object.assign({}, _props))
                                    }}
                                >
                                    <FontAwesomeIcon icon={['fas', 'times']} />
                                </div>
                                <div className="wd-mobile-navigation-tabs-config-content">
                                    <div className="section">
                                        <Label>Label</Label>
                                        <Input
                                            value={f.label}
                                            onChange={v => {
                                                updateFieldProps(i, 'label', v)
                                            }}
                                            className="widget-designer-input"
                                        />
                                    </div>
                                </div>

                                <div className="wd-mobile-navigation-tabs-config-content">
                                    <div className="section">
                                        <Label>Value one </Label>
                                        <WidgetDesignerPillInput
                                            value={f.value1}
                                            onChange={v => {
                                                updateFieldProps(i, 'value1', v)
                                            }}
                                            className="widget-designer-input"
                                            contextData={data}
                                        />
                                    </div>
                                </div>

                                <div className="wd-mobile-navigation-tabs-config-content">
                                    <div className="section">
                                        <Label>Value Two </Label>
                                        <WidgetDesignerPillInput
                                            value={f.value2}
                                            onChange={v => {
                                                updateFieldProps(i, 'value2', v)
                                            }}
                                            className="widget-designer-input"
                                            contextData={data}
                                        />
                                    </div>
                                </div>

                            </div>))}
                        </React.Fragment>
                        <div className="wd-mobile-navigation-tabs-config-tab">
                            <Button
                                className="new-option"
                                title="Add Detail"
                                icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                                iconPosition="right"
                                onClick={addNew}
                                active
                            />
                        </div>
                    </div>

                </PropertyGroup>
            </PropertyContainer>
        }
    }
}
